<template>
    <div class="activityguidepage" v-if="false">
        活动引导页
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    created(){
        let crmBaseUrl = process.env.VUE_APP_CRM_BASEURL
        let url = `${crmBaseUrl}temporary.html#/specialposter?loginChannel=76`
        window.location.href=url
    },
    mounted(){
    },
    methods:{

    }
}
</script>
<style lang="less" scoped>
.activityguidepage{
    text-align: center;
}
</style>
